import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { parse } from '../../util/urlHelpers';
import { storableError } from '../../util/errors';
import { request } from '../../util/api';
const fetchFarmersPayloadCreator = async (params, { rejectWithValue }) => {
  const { location, farmerName } = params || {};
  try {
    const queryParams = new URLSearchParams();
    if (location) queryParams.append('location', location);
    if (farmerName) queryParams.append('farmerName', farmerName);

    const response = await request(`/api/farmers?${queryParams.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    console.log(response);
    return response;
  } catch (error) {
    console.error('Error fetching farmers:', error);
    return rejectWithValue(storableError(error));
  }
};

export const fetchFarmers = createAsyncThunk(
  'FarmersPage/fetchFarmers',
  fetchFarmersPayloadCreator
);

// ================ Slice ================ //

const initialState = {
  farmers: {
    data: [],
    included: [],
    meta: {},
  },
  fetchFarmersInProgress: false,
  fetchFarmersError: null,
};

const farmersPageSlice = createSlice({
  name: 'FarmersPage',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFarmers.pending, state => {
        state.fetchFarmersInProgress = true;
        state.fetchFarmersError = null;
      })
      .addCase(fetchFarmers.fulfilled, (state, action) => {
        state.fetchFarmersInProgress = false;
        state.farmers = action.payload;
      })
      .addCase(fetchFarmers.rejected, (state, action) => {
        state.fetchFarmersInProgress = false;
        state.fetchFarmersError = action.payload;
      });
  },
});

export const actions = farmersPageSlice.actions;

// ================ Selectors ================ //

export const selectFarmers = state => state.FarmersPage.farmers;
export const selectFetchFarmersInProgress = state => state.FarmersPage.fetchFarmersInProgress;
export const selectFetchFarmersError = state => state.FarmersPage.fetchFarmersError;

// ================ Load Data ================ //

export const loadData = (params, search, config) => (dispatch, getState) => {
  const { location, farmerName } = parse(search);
  return dispatch(fetchFarmers({ location, farmerName }));
};

export default farmersPageSlice.reducer;
